import React, { ReactElement } from 'react';
import { Immutable, safeRest } from '@wds/utils';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import useStyles from './useStylesNotificationItem';

export type NotificationItemProps = Immutable<{
  children: ReactElement;
  read?: boolean;
  date: string;
  time: string;
}>;

const NotificationItem = ({
  children,
  read = false,
  date,
  time,
  ...rest
}: NotificationItemProps): ReactElement => {
  const { notificationsItem } = useStyles({ read });

  return (
    <li className={notificationsItem} {...safeRest(rest)}>
      <Box mb={2}>
        <Typography component="p" variant="bodySm" color="darkMuted">
          {date}&nbsp;&nbsp;&nbsp;{time}
        </Typography>
      </Box>
      <Typography weight={!read ? 'medium' : 'regular'}>{children}</Typography>
    </li>
  );
};

export default NotificationItem;
export { NotificationItem };
